module.exports = __webpack_public_path__ + "h5/img/id_back.128a5369.png";